/**
 * Wizard 4 plan: flavors, overview, snacks, prices, cart lines.
 * Bag counts are each dog's own plan. The charged first box is the combined-weight variant.
 */
(function () {
  var ORDER = ['rund', 'kip', 'vis'];
  var EXTRAS = [
    { id: 'beef_trainers', variantId: '58724644520200' },
    { id: 'lamb_tripe', variantId: '58584639537416' },
    { id: 'duck_trainers', variantId: '58724667097352' },
    { id: 'sardine_oil', variantId: '58163254657288' }
  ];
  var EXTRA_ACCENT = {
    scoop: 'freshwater',
    beef_trainers: 'beef',
    lamb_tripe: 'lamb',
    duck_trainers: 'duck',
    sardine_oil: 'freshwater'
  };
  var FLAVOR_PHOTO = {
    rund: 'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/beef_flatlay.webp?v=1769419117',
    kip: 'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/chicken_flatlay.webp?v=1769419117',
    vis: 'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/fish_flatlay.webp?v=1769419091'
  };
  var ADDED_TICK = 'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/tick_wrap_white.svg?v=1788260707';
  var SAMPLES = { rund: '58584603427080', kip: '58584603459848', vis: '58584603492616' };
  var SCOOP_ID = '58329766461704';
  var GUIDE_ID = '54147127148808';
  var ALLERGY = {
    beef: 'rund', rund: 'rund',
    kip: 'kip', chicken: 'kip',
    vis: 'vis', fish: 'vis',
    wit_kleine_vis: 'vis', witvis: 'vis', whitefish: 'vis'
  };
  var GIFT_PAIR = ['FREEEXTRA-W4', 'GRATISEXTRA-W4'];
  var GIFT_CODE = {
    lamb_tripe: GIFT_PAIR,
    duck_trainers: GIFT_PAIR,
    beef_trainers: GIFT_PAIR,
    sardine_oil: GIFT_PAIR
  };
  var EXTRA_ALLERGY = {
    lamb_tripe: ['lam', 'lamb'],
    duck_trainers: ['eend', 'duck'],
    beef_trainers: ['rund', 'beef']
  };
  var WARNING_ICON = 'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/warning_status_color.svg?v=1768301061';

  function t(handler, key, vars) {
    var value = '';
    var copy = window.__wizardPlanCopy;
    if (copy && key.indexOf('quiz.wizard_4.') === 0) {
      var node = copy;
      key.replace('quiz.wizard_4.', '').split('.').forEach(function (part) {
        node = node && node[part];
      });
      if (typeof node === 'string') value = node;
    }
    if (!value && handler.getLocaleString) value = handler.getLocaleString(key, vars || {});
    if (!value || value === key) {
      if (handler.getLocaleString) value = handler.getLocaleString(key, vars || {}) || value;
    }
    if (vars) {
      Object.keys(vars).forEach(function (name) {
        value = String(value).replace(new RegExp('%\\{' + name + '\\}', 'g'), vars[name]);
      });
    }
    return value;
  }

  function esc(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function nl() {
    return String(document.documentElement.lang || '').toLowerCase().indexOf('nl') === 0;
  }

  function joinNames(names) {
    var clean = names.filter(Boolean);
    var andWord = nl() ? 'en' : 'and';
    if (clean.length <= 1) return clean[0] || '';
    if (clean.length === 2) return clean[0] + ' ' + andWord + ' ' + clean[1];
    return clean.slice(0, -1).join(', ') + ' ' + andWord + ' ' + clean[clean.length - 1];
  }

  function accentPiece(name, index) {
    var shape = ((Number(index) || 0) % 5) + 1;
    return '  <span class="accent accent--freshwater shape_' + shape + ' nowrap">' + esc(name) + '</span>  ';
  }

  function accentedNames(names) {
    var clean = names.filter(Boolean);
    var andWord = nl() ? 'en' : 'and';
    if (clean.length <= 1) return accentPiece(clean[0] || '', 0);
    var last = accentPiece(clean[clean.length - 1], clean.length - 1);
    var head = clean.slice(0, -1).map(function (name, index) {
      return accentPiece(name, index);
    }).join(',');
    return head + andWord + last;
  }

  function configOf(handler) {
    return handler.flow.config || {};
  }

  function engine(handler) {
    return handler.flow.calculationEngine;
  }

  function wholeKg(kg) {
    var w = Number(kg);
    if (!Number.isFinite(w) || w < 1) return 1;
    return Math.min(100, Math.max(1, Math.round(w)));
  }

  function adultTrialBags(kg) {
    var w = wholeKg(kg);
    if (w >= 24) return 3;
    if (w >= 11) return 2;
    return 1;
  }

  function trialBags(kg, introBags) {
    var intro = Math.max(0, Math.round(Number(introBags) || 0));
    return Math.max(adultTrialBags(kg), intro || 1);
  }

  function bandFor(handler, kg) {
    var bands = configOf(handler).bagPriceBands || [];
    var w = Math.min(Math.max(Number(kg) || 1, 1), 100);
    var found = bands.find(function (row) { return w >= row.min_kg && w <= row.max_kg; });
    return found || bands[bands.length - 1] || { shopify_eur: 0, sub_eur: 0 };
  }

  function checkoutVariant(handler, kg, bagCount) {
    var rows = configOf(handler).checkoutBoxVariants || [];
    var w = wholeKg(kg);
    var bags = Math.min(22, Math.max(1, Math.round(Number(bagCount) || 1)));
    var portion = handler.flow.state.planPortion === 'mostly' ? 'mostly' : 'complete';
    var match = rows.find(function (row) {
      return w >= row.min_kg && w <= row.max_kg && Number(row.bags) === bags && (row.portion || 'complete') === portion;
    });
    if (match) return match;
    var samePackage = rows.filter(function (row) { return Number(row.bags) === bags; });
    return samePackage[samePackage.length - 1] || rows[rows.length - 1];
  }

  function shippingDays() {
    var rates = window.__wizardShippingRates || {};
    var cc = String(window.__wizardCurrentCountry || 'NL').toUpperCase();
    var row = rates[cc];
    var days = row && Number(row.deliveryDays);
    return Number.isFinite(days) ? Math.max(0, Math.round(days)) : 1;
  }

  function dogPlan(handler, dog) {
    var calc = engine(handler).calculate({
      name: dog.name,
      gender: dog.gender,
      spayed: dog.spayed,
      ageGroup: dog.ageGroup,
      breed: dog.breed,
      weight: Number(dog.weight) || 1,
      composition: dog.composition,
      activity: dog.activity,
      snacks: dog.snacks,
      allergies: dog.allergies || []
    });
    var ongoingBags = Math.max(1, Number(calc.bagCount) || 1);
    var flavorBags = ongoingBags;
    var onW5 = window.BzWizard && window.BzWizard.id && window.BzWizard.id() === 'w5';
    if (onW5 && window.WizardW5 && window.WizardW5.bagsForDog) {
      var planned = Number(window.WizardW5.bagsForDog(handler, dog));
      if (Number.isFinite(planned) && planned > 0) flavorBags = planned;
    }
    var maxFlavors = Math.max(1, Math.min(flavorBags, 3));
    if (onW5 && isPicky(dog)) maxFlavors = 3;
    return {
      calc: calc,
      trialBags: trialBags(dog.weight, calc.introBagCount),
      ongoingBags: ongoingBags,
      maxFlavors: maxFlavors
    };
  }

  function beefPremiumListEur(handler) {
    var value = Number(configOf(handler).beefPremiumEur);
    return Number.isFinite(value) && value > 0 ? value : 0;
  }

  function beefBagCount(bags, flavors) {
    var selected = (flavors || []).filter(function (id) {
      return id === 'rund' || id === 'kip' || id === 'vis';
    });
    if (!selected.length || selected.indexOf('rund') === -1) return 0;
    if (window.FlavorDistribution && window.FlavorDistribution.calculateFlavorDistribution) {
      var dist = window.FlavorDistribution.calculateFlavorDistribution(bags, selected);
      return Number(dist.rund) || 0;
    }
    return Math.max(0, Math.floor(Number(bags) || 0));
  }

  function beefExtraPerDay(handler, plan, flavors) {
    var premium = beefPremiumListEur(handler);
    if (!premium || !plan) return 0;
    var list = flavors && flavors.indexOf('rund') !== -1 ? flavors : ['rund'];
    var bags = beefBagCount(plan.ongoingBags, list);
    if (!bags) return 0;
    var mostly = handler.flow.state.planPortion === 'mostly';
    var days = Math.round(Number(plan.calc.matchDays) || 25);
    var shown = mostly ? Math.round(days * 5 / 3) : days;
    if (!shown) return 0;
    return premium * bags / shown;
  }

  function premiumLabel(amount) {
    var text = (Math.round(Number(amount) * 100) / 100).toFixed(2);
    var lang = (document.documentElement.lang || 'nl').toLowerCase();
    if (lang.indexOf('en') !== 0) text = text.replace('.', ',');
    return '+€ ' + text;
  }

  function beefPremiumTip(handler) {
    var key = 'quiz.wizard_4.flavors.premium_tip';
    var value = t(handler, key);
    if (value && value !== key) return value;
    return nl()
      ? 'Deze maaltijd heeft een extra toeslag. De ingrediënten kosten namelijk wat meer. In je eerste box kun je de maaltijd proberen zonder extra toeslag 🩵'
      : 'This meal has an extra charge. The ingredients cost a bit more. In your first box you can try the meal without the extra charge 🩵';
  }

  function beefPremiumHtml(handler, plan, flavors) {
    if (!beefPremiumListEur(handler)) return '';
    var amount = beefExtraPerDay(handler, plan, flavors);
    if (!amount) return '';
    var tip = beefPremiumTip(handler);
    return (
      '<span class="wizard-flavor-premium wizard-tip">' +
        '<span class="wizard-text-link wizard-flavor-premium__price">' + esc(premiumLabel(amount)) + '</span>' +
        '<button type="button" class="wizard-flavor-premium__help" aria-label="' + esc(tip) + '">' +
          '<img src="https://cdn.shopify.com/s/files/1/0919/3534/2856/files/Question_2.svg?v=1791970943" alt="" width="18" height="18">' +
        '</button>' +
        '<span class="wizard-tip__bubble" role="tooltip">' + esc(tip) + '</span>' +
      '</span>'
    );
  }

  function household(handler) {
    var state = handler.flow.state;
    var dogs = state.ensureDogs();
    var plans = dogs.map(function (dog) { return dogPlan(handler, dog); });
    var combinedKg = state.combinedWeightKg();
    var priceBand = bandFor(handler, combinedKg);
    var shippedBags = plans.reduce(function (sum, plan) { return sum + plan.trialBags; }, 0);
    var box = checkoutVariant(handler, combinedKg, shippedBags);
    var variantBags = Math.max(1, shippedBags);
    var foodDays = plans.reduce(function (min, plan) {
      var grams = Number(plan.calc.dailyFoodG) || 0;
      var bags = Math.max(1, Number(plan.trialBags) || 1);
      var days = grams > 0 ? Math.max(1, Math.round((bags * 1000) / grams)) : 1;
      return Math.min(min, days);
    }, 999);
    if (!Number.isFinite(foodDays) || foodDays === 999) foodDays = 1;
    var ongoingDays = plans.reduce(function (min, plan) {
      var days = Math.round(Number(plan.calc.matchDays) || 25);
      return Math.min(min, days);
    }, 999);
    if (!Number.isFinite(ongoingDays) || ongoingDays === 999) ongoingDays = 25;
    var mostly = state.planPortion === 'mostly';
    if (window.WizardHousehold && window.WizardHousehold.releaseLargeDogOfferIfLight) {
      window.WizardHousehold.releaseLargeDogOfferIfLight(handler);
    }
    var box1Pct = state.largeDogOffer === 'accept' && state.combinedWeightKg() >= 30 ? 0.35 : 0.25;
    var listEur = box && box.list_eur != null ? Number(box.list_eur) : 0;
    var box1Eur = listEur * (1 - box1Pct);
    var shownFoodDays = mostly ? Math.max(1, Math.round(foodDays * 5 / 3)) : foodDays;
    var box1PerDay = shownFoodDays > 0 ? box1Eur / shownFoodDays : 0;
    var ongoingBags = plans.reduce(function (sum, plan) { return sum + plan.ongoingBags; }, 0);
    var factor = mostly ? 1.417 : 1;
    var customerPerBag = priceBand.sub_eur != null ? Number(priceBand.sub_eur) : (priceBand.shopify_eur || 0) * 0.9;
    var beefBags = plans.reduce(function (sum, plan, index) {
      return sum + beefBagCount(plan.ongoingBags, dogs[index].flavors || []);
    }, 0);
    var ongoingDaysShown = mostly ? Math.max(1, Math.round(ongoingDays * 5 / 3)) : ongoingDays;
    var ongoingEur = customerPerBag * factor * ongoingBags + beefPremiumListEur(handler) * beefBags;
    var ongoingPerDay = ongoingDaysShown > 0 ? ongoingEur / ongoingDaysShown : 0;
    return {
      dogs: dogs,
      plans: plans,
      combinedKg: combinedKg,
      priceBand: priceBand,
      box: box,
      variantBags: variantBags,
      foodDays: foodDays,
      shownFoodDays: shownFoodDays,
      transitionDays: 3,
      shippingDays: shippingDays(),
      box1PerDay: box1PerDay,
      ongoingPerDay: ongoingPerDay,
      ongoingDays: ongoingDaysShown,
      mostly: mostly
    };
  }

  function feeding(grams) {
    var foodG = Math.round(Number(grams) || 0);
    var foodScoops = Math.round((foodG / 45) * 2) / 2;
    if (foodScoops < 0.25) foodScoops = 0.25;
    var waterScoops = Math.round((foodScoops / 2.5) * 2) / 2;
    if (waterScoops < 0.25) waterScoops = 0.25;
    return { grams: foodG, foodScoops: foodScoops, waterMl: Math.round(waterScoops * 80), scoops: waterScoops };
  }

  function money(amount) {
    var cents = Math.round(Number(amount) * 100);
    if (typeof window.formatMoney === 'function') {
      return window.formatMoney(cents / 100, 'EUR', document.documentElement.lang || 'nl');
    }
    return '€' + (cents / 100).toFixed(2);
  }

  var FLAVOR_ACCENT = { rund: 'accent--beef shape_2', kip: 'accent--chicken shape_3', vis: 'accent--fish shape_4' };
  var MODAL = { rund: 'beef', kip: 'chicken', vis: 'fish' };
  var SAMPLE_MODAL = { rund: 'beef-sample', kip: 'chicken-sample', vis: 'fish-sample' };
  var EXTRA_MODAL = {
    beef_trainers: 'beef-trainers',
    lamb_tripe: 'lamb-tripe',
    duck_trainers: 'duck-trainers',
    sardine_oil: 'sardine-oil'
  };
  var flavorTaglines = {};
  var HERO = 'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/A7402675_2.webp?v=1782378576';
  var FEED_MARK = 'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/food-water.webp?v=1789114358';
  var INFO_ICON = 'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/Info_3.svg?v=1768299821';
  var TRANSITION_ARROW = 'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/arrow-down_600.svg?v=1766993985';
  var BOWL = {
    complete: 'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/filled_bowl.webp?v=1773925349',
    mostly: 'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/filled_bowl_3_5.webp?v=1790680976'
  };
  var TRUST_STARS = 'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/tp_stars.webp?v=1790322859';
  var CHECK = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3.2 8.4 6.4 11.6 12.8 4.4" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function flavorName(handler, id) {
    return t(handler, 'quiz.steps.flavors.flavor_' + id);
  }

  function firstFlavor(selected) {
    var i;
    for (i = 0; i < ORDER.length; i++) {
      if (selected.indexOf(ORDER[i]) !== -1) return ORDER[i];
    }
    return selected[0] || '';
  }

  function pronoun(dog) {
    if (nl()) return dog.gender === 'male' ? 'zijn' : 'haar';
    return dog.gender === 'male' ? 'his' : 'her';
  }

  function boxWord(dog) {
    if (dog.gender !== 'female' && dog.gender !== 'male') return nl() ? 'jouw' : 'your';
    return pronoun(dog);
  }

  function allergic(dog, flavorId) {
    return (dog.allergies || []).some(function (token) {
      return ALLERGY[String(token).toLowerCase()] === flavorId;
    });
  }

  function dogHasToken(dog, tokens) {
    return (dog.allergies || []).some(function (token) {
      return tokens.indexOf(String(token).toLowerCase()) !== -1;
    });
  }

  function dogsWithToken(dogs, tokens) {
    return (dogs || []).filter(function (dog) { return dogHasToken(dog, tokens); });
  }

  function freeGiftId(dogs) {
    if (!dogsWithToken(dogs, EXTRA_ALLERGY.lamb_tripe).length) return 'lamb_tripe';
    if (!dogsWithToken(dogs, EXTRA_ALLERGY.duck_trainers).length) return 'duck_trainers';
    if (!dogsWithToken(dogs, EXTRA_ALLERGY.beef_trainers).length) return 'beef_trainers';
    return 'sardine_oil';
  }

  function giftIsOn(state, giftId) {
    return state.freeGiftOff !== giftId;
  }

  function giftProps() {
    return {
      _journey_id: window.BzWizard.id(),
      _acquisition_flow: window.BzWizard.flow(),
      _journey_gift: '1'
    };
  }

  function allergyWarningHtml(handler, names) {
    var clean = (names || []).filter(Boolean);
    if (!clean.length) return '';
    var text = t(handler, 'quiz.steps.flavors.allergy_warning', { pet_name: joinNames(clean) });
    if (!text || text === 'quiz.steps.flavors.allergy_warning') return '';
    return '<div class="inline-message" data-message-type="warning">' +
      '<span class="warning-icon" aria-hidden="true"><img src="' + WARNING_ICON + '" alt="" width="16" height="16"></span>' +
      '<p class="inline-message-text">' + esc(text) + '</p></div>';
  }

  function syncLegacyFlavors(state) {
    var all = [];
    state.ensureDogs().forEach(function (dog) {
      (dog.flavors || []).forEach(function (id) {
        if (all.indexOf(id) === -1) all.push(id);
      });
    });
    state.selectedFlavorsTrial = all.slice();
    state.selectedFlavorsFull = all.slice();
  }

  var flavorDogsSeen = [];

  function flavorActiveIndex() {
    var root = document.querySelector('[data-wizard-flavors]');
    var active = Number(root && root.getAttribute('data-active-dog') || '0');
    return Number.isFinite(active) ? active : 0;
  }

  function markFlavorSeen(index) {
    if (flavorDogsSeen.indexOf(index) === -1) flavorDogsSeen.push(index);
  }

  function nextFlavorDog(state) {
    var dogs = state.ensureDogs();
    var i;
    for (i = 0; i < dogs.length; i++) {
      if (flavorDogsSeen.indexOf(i) === -1) return i;
    }
    for (i = 0; i < dogs.length; i++) {
      if (!(dogs[i].flavors || []).length) return i;
    }
    return -1;
  }

  function canContinueFlavors(state) {
    var dogs = state.ensureDogs();
    var dog = dogs[flavorActiveIndex()] || dogs[0];
    return !!(dog && (dog.flavors || []).length);
  }

  function advanceFlavors(handler) {
    var state = handler.flow.state;
    var dogs = state.ensureDogs();
    var active = flavorActiveIndex();
    var current = dogs[active];
    if (!current || !(current.flavors || []).length) return true;
    markFlavorSeen(active);
    var next = nextFlavorDog(state);
    if (next === -1) return false;
    var root = handler.currentStepElement && handler.currentStepElement.querySelector('[data-wizard-flavors]');
    if (root) root.setAttribute('data-active-dog', String(next));
    markFlavorSeen(next);
    mountFlavors(handler);
    return true;
  }

  function setFooter(step) {
    var footer = document.querySelector('[data-plan-price-footer]');
    if (!footer) return;
    footer.style.display = step === 'plan_overview' ? '' : 'none';
    footer.querySelectorAll('select').forEach(function (select) {
      select.style.display = 'none';
    });
    footer.querySelectorAll('[data-sticky-trial-row], [data-sticky-full-plan-row]').forEach(function (row) {
      row.style.display = '';
    });
    syncOverviewFooterClearance(step);
  }

  function syncOverviewFooterClearance(step) {
    var quiz = document.querySelector('.quiz-content');
    if (!quiz) return;
    if (step !== 'plan_overview') {
      quiz.style.paddingBottom = '';
      return;
    }
    var bar = document.querySelector('.quiz-footer');
    var root = document.querySelector('[data-wizard-overview]');
    if (!bar || !root) return;
    var height = bar.offsetHeight + 'px';
    root.style.setProperty('--wizard-footer-h', height);
    quiz.style.paddingBottom = height;
  }

  function paintSticky(handler, model) {
    var trialLabel = document.querySelector('[data-sticky-trial-label]');
    var fullLabel = document.querySelector('[data-sticky-full-plan-label]');
    var trialPrice = document.querySelector('[data-sticky-trial-final]');
    var fullPrice = document.querySelector('[data-sticky-full-final]');
    var trialCompare = document.querySelector('[data-sticky-trial-compare]');
    var fullCompare = document.querySelector('[data-sticky-full-compare]');
    if (trialLabel) trialLabel.textContent = t(handler, 'quiz.wizard_4.overview.sticky_1');
    if (fullLabel) fullLabel.textContent = t(handler, 'quiz.wizard_4.overview.sticky_2');
    var perDay = ' / ' + t(handler, 'quiz.wizard_4.overview.day');
    if (trialPrice) {
      trialPrice.textContent = money(model.box1PerDay);
      var suffix = document.createElement('span');
      suffix.className = 'wizard-sticky-period-suffix';
      suffix.textContent = perDay;
      trialPrice.appendChild(suffix);
    }
    if (fullPrice) fullPrice.textContent = money(model.ongoingPerDay) + perDay;
    if (trialCompare) trialCompare.textContent = '';
    if (fullCompare) fullCompare.textContent = '';
  }

  function chip(name, index, active) {
    var shape = (index % 5) + 1;
    return '<button type="button" class="wizard-dog-chip' + (active ? ' is-selected' : '') + '" data-dog-chip="' + index + '">' +
      '<span class="accent shape_' + shape + ' nowrap">' + esc(name) + '</span></button>';
  }

  function defaultFlavors(dog, maxFlavors) {
    var picked = [];
    ORDER.forEach(function (id) {
      if (picked.length >= maxFlavors) return;
      if (allergic(dog, id)) return;
      picked.push(id);
    });
    return picked;
  }

  function sameFlavorSet(a, b) {
    if (!a || !b || a.length !== b.length) return false;
    return a.every(function (id) { return b.indexOf(id) !== -1; });
  }

  function dropFlavorForSwap(list, dog, plan) {
    var next = list.slice();
    if (!next.length) return next;
    var defaults = defaultFlavors(dog, plan.maxFlavors);
    var untouched = !dog.flavorsTouched && sameFlavorSet(next, defaults);
    var victim = next[next.length - 1];
    if (untouched) {
      ORDER.forEach(function (id) {
        if (next.indexOf(id) !== -1) victim = id;
      });
    }
    var at = next.indexOf(victim);
    if (at !== -1) next.splice(at, 1);
    return next;
  }

  function trimFlavorList(list, max) {
    var selected = (list || []).slice();
    var removeOrder = window.FlavorDistribution && window.FlavorDistribution.getFlavorTrimOrder
      ? window.FlavorDistribution.getFlavorTrimOrder()
      : ORDER.slice().reverse();
    while (selected.length > max) {
      var victim = removeOrder.find(function (id) { return selected.indexOf(id) !== -1; });
      if (!victim) break;
      selected.splice(selected.indexOf(victim), 1);
    }
    return selected;
  }

  function enforceFlavorCaps(handler) {
    var state = handler.flow.state;
    var model = household(handler);
    var changed = false;
    model.dogs.forEach(function (dog, index) {
      var plan = model.plans[index];
      var selected = dog.flavors || [];
      if (!plan || selected.length <= plan.maxFlavors) return;
      state.setDogField(index, 'flavors', trimFlavorList(selected, plan.maxFlavors));
      changed = true;
    });
    if (changed) syncLegacyFlavors(state);
  }

  function ensureDefaultFlavors(handler) {
    var state = handler.flow.state;
    var model = household(handler);
    var changed = false;
    model.dogs.forEach(function (dog, index) {
      if (dog.flavorsDefaulted) return;
      var plan = model.plans[index];
      if (!(dog.flavors || []).length && plan) {
        state.setDogField(index, 'flavors', defaultFlavors(dog, plan.maxFlavors));
        state.setDogField(index, 'flavorsTouched', false);
        changed = true;
      } else if ((dog.flavors || []).length && plan && !sameFlavorSet(dog.flavors, defaultFlavors(dog, plan.maxFlavors))) {
        state.setDogField(index, 'flavorsTouched', true);
      }
      state.setDogField(index, 'flavorsDefaulted', true);
    });
    if (changed) syncLegacyFlavors(state);
  }

  function mountFlavors(handler) {
    var root = handler.currentStepElement.querySelector('[data-wizard-flavors]');
    if (!root) return;
    ensureDefaultFlavors(handler);
    enforceFlavorCaps(handler);
    var state = handler.flow.state;
    var model = household(handler);
    var active = Number(root.getAttribute('data-active-dog') || '0');
    if (active >= model.dogs.length) active = 0;
    markFlavorSeen(active);
    var dog = model.dogs[active];
    var plan = model.plans[active];
    var selected = dog.flavors || [];
    var flavorRow = root.querySelector('.wizard-flavor-row');
    var keepScroll = flavorRow ? flavorRow.scrollLeft : 0;
    var chips = model.dogs.length > 1
      ? model.dogs.map(function (item, index) {
        return chip(item.name, index, index === active);
      }).join('')
      : '';
    var cards = ORDER.map(function (id) {
      var on = selected.indexOf(id) !== -1;
      var warn = allergic(dog, id);
      return (
        '<article class="wizard-flavor-card' + (on ? ' is-selected' : '') + '" data-flavor-card="' + id + '">' +
          '<div class="wizard-flavor-card__media">' +
            '<img alt="" data-flavor-img="' + id + '" src="' + FLAVOR_PHOTO[id] + '">' +
            (on ? '<span class="wizard-flavor-card__chosen">' + CHECK + esc(t(handler, 'quiz.wizard_4.flavors.chosen', { name: dog.name || '', pronoun: boxWord(dog) })) + '</span>' : '') +
          '</div>' +
          '<div class="wizard-flavor-card__body">' +
            '<div class="wizard-flavor-card__info">' +
              '<h3 class="wizard-h5 wizard-flavor-card__name"><span class="accent ' + FLAVOR_ACCENT[id] + ' nowrap">' + esc(flavorName(handler, id)) + '</span>' +
                (id === 'rund' ? beefPremiumHtml(handler, plan, selected) : '') +
              '</h3>' +
              '<p class="wizard-body-secondary wizard-flavor-card__blurb" data-flavor-blurb="' + id + '">' + esc(flavorTaglines[id] || '') + '</p>' +
              '<button type="button" class="wizard-text-link" data-open-flavor-modal="' + MODAL[id] + '">' + esc(t(handler, 'quiz.wizard_4.flavors.details')) + '</button>' +
              (warn ? allergyWarningHtml(handler, [dog.name]) : '') +
            '</div>' +
            '<button type="button" class="' + (on ? 'wizard-card-button' : 'wizard-primary-button') + '" data-flavor-toggle="' + id + '">' +
              esc(on ? t(handler, 'quiz.wizard_4.flavors.remove') : t(handler, 'quiz.wizard_4.flavors.add')) +
            '</button>' +
          '</div>' +
        '</article>'
      );
    }).join('');
    root.innerHTML =
      '<h2 class="quiz-title wizard-step-title">' + esc(t(handler, 'quiz.wizard_4.flavors.title')) + '</h2>' +
      '<p class="wizard-support wizard-center">' + esc(t(handler, 'quiz.wizard_4.flavors.intro', { pronoun: pronoun(dog) })) + '</p>' +
      (chips ? '<div class="wizard-dog-chips">' + chips + '</div>' : '') +
      '<p class="wizard-support wizard-center">' + esc(t(handler, plan.maxFlavors === 1 ? 'quiz.wizard_4.flavors.hint_one' : 'quiz.wizard_4.flavors.hint', { n: String(plan.maxFlavors) })) + '</p>' +
      '<div class="wizard-flavor-row">' + cards + '</div>';
    root.querySelectorAll('[data-dog-chip]').forEach(function (button) {
      button.addEventListener('click', function () {
        root.setAttribute('data-active-dog', button.getAttribute('data-dog-chip'));
        mountFlavors(handler);
      });
    });
    root.querySelectorAll('[data-flavor-toggle]').forEach(function (button) {
      button.addEventListener('click', function () {
        var id = button.getAttribute('data-flavor-toggle');
        var list = (dog.flavors || []).slice();
        var at = list.indexOf(id);
        if (at === -1) {
          if (list.length >= plan.maxFlavors) list = dropFlavorForSwap(list, dog, plan);
          if (list.indexOf(id) === -1) list.push(id);
        } else {
          list.splice(at, 1);
        }
        state.setDogField(active, 'flavors', list);
        state.setDogField(active, 'flavorsTouched', true);
        syncLegacyFlavors(state);
        mountFlavors(handler);
      });
    });
    var nextRow = root.querySelector('.wizard-flavor-row');
    if (nextRow && keepScroll) {
      nextRow.scrollLeft = keepScroll;
      requestAnimationFrame(function () {
        nextRow.scrollLeft = keepScroll;
      });
    }
    fillFlavorMedia(handler, root);
    setFooter('flavors');
    if (handler.updateButtonStates) handler.updateButtonStates('flavors');
  }

  function fillFlavorMedia(handler, root) {
    var vids = configOf(handler).variantIds || {};
    ORDER.forEach(function (id) {
      var vid = vids[id];
      if (!vid || !handler.flow.shopifyAPI || !handler.flow.shopifyAPI.getVariant) return;
      handler.flow.shopifyAPI.getVariant(vid).then(function (variant) {
        var line = variant && variant.tagline ? String(variant.tagline).trim() : '';
        flavorTaglines[id] = line;
        var blurb = document.querySelector('[data-wizard-flavors] [data-flavor-blurb="' + id + '"]');
        if (blurb) blurb.textContent = line;
      }).catch(function () {});
    });
  }

  function dayWord(handler, days) {
    var n = Math.max(1, Math.round(days));
    var key = n === 1 ? 'quiz.wizard_4.overview.day' : 'quiz.wizard_4.overview.days';
    return n + ' ' + t(handler, key);
  }

  function formatScoopCount(scoops) {
    if (!Number.isFinite(scoops) || scoops <= 0) return '';
    if (Math.abs(scoops - 0.25) < 0.001) return '¼';
    var whole = Math.floor(scoops);
    var fraction = Math.round((scoops - whole) * 2) / 2;
    if (fraction === 0) return String(whole);
    if (fraction === 0.5) return whole === 0 ? '½' : whole + '½';
    return String(scoops);
  }

  function scoopParts(handler, scoops) {
    var key = scoops < 2 ? 'quiz.wizard_4.overview.scoop' : 'quiz.wizard_4.overview.scoops';
    return {
      number: formatScoopCount(scoops),
      unit: t(handler, key)
    };
  }

  function isPicky(dog) {
    return dog.eating === 'picky' || dog.eating === 'very_picky';
  }

  function sampleFlavors(dog) {
    if (!isPicky(dog)) return [];
    var selected = dog.flavors || [];
    return ORDER.filter(function (id) {
      return selected.indexOf(id) === -1 && !allergic(dog, id);
    });
  }

  function sampleLine(handler, dog) {
    var extras = sampleFlavors(dog);
    if (!extras.length) return '';
    var names = extras.map(function (id) {
      return '<button type="button" class="wizard-text-link" data-open-flavor-modal="' + SAMPLE_MODAL[id] + '">' + esc(flavorName(handler, id)) + '</button>';
    });
    var andWord = nl() ? 'en' : 'and';
    var joined = names.length === 1 ? names[0] : names[0] + ' ' + andWord + ' ' + names[1];
    return '<p class="wizard-body-tertiary wizard-center wizard-sample-line">' +
      esc(t(handler, 'quiz.wizard_4.overview.sample_lead')) + ' ' + joined + ' ' +
      esc(t(handler, 'quiz.wizard_4.overview.sample_tail', { name: dog.name, pronoun: pronoun(dog) })) +
      '</p>';
  }

  function mountOverview(handler) {
    var root = handler.currentStepElement.querySelector('[data-wizard-overview]');
    if (!root) return;
    var state = handler.flow.state;
    if (state.planPortion !== 'mostly') state.planPortion = 'complete';
    var model = household(handler);
    var active = Number(root.getAttribute('data-active-dog') || '0');
    if (active >= model.dogs.length) active = 0;
    var dog = model.dogs[active];
    var plan = model.plans[active];
    var grams = plan.calc.dailyFoodG * (model.mostly ? 0.6 : 1);
    var feed = feeding(grams);
    var names = joinNames(model.dogs.map(function (item) { return item.name; }));
    var title = model.dogs.length > 1
      ? esc(t(handler, 'quiz.wizard_4.overview.title_multi'))
      : t(handler, 'quiz.wizard_4.overview.title_one').replace(/\s*%\{name\}\s*/g, accentPiece(dog.name, 0));
    var chips = model.dogs.length > 1
      ? '<div class="wizard-dog-chips">' + model.dogs.map(function (item, index) {
        return chip(item.name, index, index === active);
      }).join('') + '</div>'
      : '';
    var mealDays = Math.round(model.shownFoodDays + (model.transitionDays || 0));
    var trialDays = mealDays + model.shippingDays;
    var mealQty = flavorQtyParts(handler, plan.trialBags, dog.flavors || []).join(', ');
    var foodScoops = scoopParts(handler, feed.foodScoops);
    var waterScoops = scoopParts(handler, feed.scoops);
    var whyText = t(handler, 'quiz.wizard_4.overview.why_body', { name: dog.name, pronoun: pronoun(dog) });
    root.innerHTML =
      '<h2 class="quiz-title">' + title + '</h2>' +
      '<section class="wizard-plan-card">' +
        '<div class="wizard-plan-card__body">' +
          '<h3 class="wizard-h5">' + esc(t(handler, 'quiz.wizard_4.overview.first_title')) + '</h3>' +
          '<p class="wizard-body-secondary wizard-center">' + esc(t(handler, 'quiz.wizard_4.overview.first_body', { names: names, days: dayWord(handler, mealDays) })) + '</p>' +
        '</div>' +
        '<div class="wizard-feed-panel">' +
          '<img class="wizard-plan-card__hero" alt="" src="' + HERO + '">' +
          '<div class="wizard-feed-panel__body">' +
            chips +
            '<p class="wizard-body-secondary wizard-center">' + esc(t(handler, 'quiz.wizard_4.overview.per_day', { qty: mealQty, days: dayWord(handler, mealDays) })) + '</p>' +
            '<div class="wizard-feed">' +
              '<div class="wizard-feed__col">' +
                '<p class="wizard-body-secondary"><strong>' + esc(String(feed.grams)) + '</strong>g Forever Food</p>' +
                '<p class="wizard-body-secondary">(±<strong>' + esc(foodScoops.number) + '</strong> ' + esc(foodScoops.unit) + ')</p>' +
              '</div>' +
              '<img class="wizard-feed__mark" alt="" src="' + FEED_MARK + '">' +
              '<div class="wizard-feed__col">' +
                '<p class="wizard-body-secondary"><strong>' + esc(String(feed.waterMl)) + '</strong>ml water</p>' +
                '<p class="wizard-body-secondary">(±<strong>' + esc(waterScoops.number) + '</strong> ' + esc(waterScoops.unit) + ')</p>' +
              '</div>' +
            '</div>' +
            '<span class="wizard-tip">' +
              '<button type="button" class="wizard-text-link">' + esc(t(handler, 'quiz.wizard_4.overview.why')) + '</button>' +
              '<span class="wizard-tip__bubble" role="tooltip">' + esc(whyText) + '</span>' +
            '</span>' +
            sampleLine(handler, dog) +
          '</div>' +
        '</div>' +
      '</section>' +
      '<div class="wizard-transition">' +
        '<img class="wizard-transition__arrow" alt="" src="' + TRANSITION_ARROW + '">' +
        '<div class="wizard-transition__text">' +
          '<p class="wizard-transition__title">' + esc(t(handler, 'quiz.wizard_4.overview.gap', { days: dayWord(handler, trialDays) })) + '</p>' +
          '<p class="wizard-body-secondary">' + esc(t(handler, 'quiz.wizard_4.overview.email_note')) + '</p>' +
        '</div>' +
      '</div>' +
      '<section class="wizard-plan-card">' +
        '<div class="wizard-plan-card__body">' +
          '<h3 class="wizard-h5">' + esc(t(handler, 'quiz.wizard_4.overview.second_title')) + '</h3>' +
          '<p class="wizard-body-secondary wizard-center">' + esc(t(handler, 'quiz.wizard_4.overview.second_body', { names: names })) + '</p>' +
          portionCard(handler, 'complete', model) +
          portionCard(handler, 'mostly', model) +
        '</div>' +
      '</section>' +
      '<p class="wizard-note wizard-body-secondary"><img class="wizard-note__icon" alt="" src="' + INFO_ICON + '"><span>' + esc(t(handler, 'quiz.wizard_4.overview.note')) + '</span></p>' +
      '<section class="wizard-trust">' +
        '<div class="wizard-trust__inner">' +
          '<img class="wizard-trust__stars" alt="Trustpilot" src="' + TRUST_STARS + '">' +
          '<p class="wizard-body">“' + esc(t(handler, 'quiz.wizard_4.overview.trust_quote')) + '”</p>' +
          '<p class="wizard-trust__name wizard-body-secondary">' + esc(t(handler, 'quiz.wizard_4.overview.trust_name')) + '</p>' +
        '</div>' +
      '</section>';
    root.querySelectorAll('[data-dog-chip]').forEach(function (button) {
      button.addEventListener('click', function () {
        root.setAttribute('data-active-dog', button.getAttribute('data-dog-chip'));
        mountOverview(handler);
      });
    });
    root.querySelectorAll('[data-portion]').forEach(function (button) {
      button.addEventListener('click', function () {
        state.planPortion = button.getAttribute('data-portion');
        if (window.WizardGa4Traits && window.WizardGa4Traits.notify) window.WizardGa4Traits.notify();
        mountOverview(handler);
      });
    });
    setFooter('plan_overview');
    paintSticky(handler, model);
    if (window.WizardHousehold && window.WizardHousehold.maybeLargeDogOffer) {
      window.WizardHousehold.maybeLargeDogOffer(handler);
    }
    if (handler.updateButtonStates) handler.updateButtonStates('plan_overview');
  }

  function portionCard(handler, portion, model) {
    var on = (model.mostly ? 'mostly' : 'complete') === portion;
    var dog = model.dogs[Number(document.querySelector('[data-wizard-overview]')?.getAttribute('data-active-dog') || '0')] || model.dogs[0];
    var plan = model.plans[model.dogs.indexOf(dog)] || model.plans[0];
    var grams = Math.round((plan.calc.dailyFoodG || 0) * (portion === 'mostly' ? 0.6 : 1));
    var title = t(handler, portion === 'mostly' ? 'quiz.wizard_4.overview.mostly' : 'quiz.wizard_4.overview.full');
    var descKey = 'quiz.wizard_4.overview.mostly_desc';
    if (portion !== 'mostly') {
      if (model.dogs.length > 1) descKey = 'quiz.wizard_4.overview.full_desc_several';
      else if (dog && dog.gender === 'male') descKey = 'quiz.wizard_4.overview.full_desc_male';
      else descKey = 'quiz.wizard_4.overview.full_desc';
    }
    var desc = t(handler, descKey);
    var badgeLabel = portion === 'complete'
      ? t(handler, 'quiz.wizard_4.overview.badge')
      : t(handler, 'quiz.wizard_4.overview.low_price');
    var portionScoops = scoopParts(handler, feeding(grams).foodScoops);
    return (
      '<button type="button" class="wizard-portion' + (on ? ' is-selected' : '') + '" data-portion="' + portion + '">' +
        '<span class="wizard-edge-badge' + (on ? '' : ' wizard-edge-badge--muted') + '">' + esc(badgeLabel) + '</span>' +
        '<span class="wizard-portion__main">' +
          '<img alt="" src="' + BOWL[portion] + '">' +
          '<span class="wizard-portion__copy">' +
            '<strong class="wizard-h5 wizard-portion__title">' + esc(title) + '</strong>' +
            '<span class="wizard-body-secondary"><strong>' + esc(portionScoops.number) + '</strong> ' + esc(portionScoops.unit) + ' ' + esc(t(handler, 'quiz.wizard_4.overview.a_day')) + '</span>' +
            '<span class="wizard-body-secondary">' + esc(desc) + '</span>' +
          '</span>' +
          '<span class="wizard-portion__radio" aria-hidden="true"></span>' +
        '</span>' +
      '</button>'
    );
  }

  var extraMedia = {};
  var extraMediaPromise = null;

  function extraItems() {
    return [{ id: 'scoop', variantId: SCOOP_ID }].concat(EXTRAS);
  }

  function preloadExtras(flow) {
    if (extraMediaPromise) return extraMediaPromise;
    if (!flow || !flow.shopifyAPI || !flow.shopifyAPI.getVariant) return null;
    extraMediaPromise = Promise.all(extraItems().map(function (item) {
      return flow.shopifyAPI.getVariant(item.variantId).then(function (variant) {
        if (variant) extraMedia[item.id] = variant;
      });
    })).catch(function (error) {
      extraMediaPromise = null;
      console.error('Wizard 4 extras failed to load', error);
      throw error;
    });
    return extraMediaPromise;
  }

  function snackLabel(item, variant) {
    if (!variant) return '';
    if (item.id === 'scoop') return (variant.product && variant.product.title) || variant.title || '';
    return variant.title || '';
  }

  function giftBadgeHtml(handler) {
    return '<span class="wizard-edge-badge wizard-edge-badge--success" data-gift-badge>🎁 ' + esc(t(handler, 'quiz.wizard_4.snacks.gift')) + '</span>';
  }

  function snackCardHtml(handler, item, index, options) {
    var gift = !!(options && options.gift);
    var variant = extraMedia[item.id];
    var label = snackLabel(item, variant);
    var on = gift ? giftIsOn(handler.flow.state, item.id) : !!handler.flow.state.extrasOn[item.id];
    var accent = EXTRA_ACCENT[item.id] || 'freshwater';
    var shape = (index % 5) + 1;
    var modal = EXTRA_MODAL[item.id] || '';
    var warnTokens = EXTRA_ALLERGY[item.id];
    var warn = !gift && warnTokens
      ? allergyWarningHtml(handler, dogsWithToken(options.dogs, warnTokens).map(function (dog) { return dog.name; }))
      : '';
    var badge = gift
      ? (on ? giftBadgeHtml(handler) : '')
      : (on
        ? '<span class="wizard-edge-badge" data-snack-badge><img alt="" src="' + ADDED_TICK + '">' + esc(t(handler, 'quiz.wizard_4.snacks.added')) + '</span>'
        : '');
    var action = gift
      ? ''
      : '<button type="button" class="' + (on ? 'wizard-card-button' : 'wizard-primary-button') + '" data-snack-toggle="' + item.id + '">' +
          esc(snackButtonLabel(handler, item.id, on)) +
        '</button>';
    return (
      '<article class="wizard-snack-card' + (gift ? ' wizard-snack-card--scoop' : '') + (on && !gift ? ' is-selected' : '') + '" data-snack="' + item.id + '">' +
        badge +
        '<div class="wizard-snack-card__top">' +
          '<div class="wizard-snack-card__media">' +
            '<img alt=""' + (variant && variant.image ? ' src="' + esc(variant.image) + '"' : '') + ' data-snack-img="' + item.id + '" data-open-flavor-modal="' + modal + '" role="button" tabindex="0">' +
          '</div>' +
          '<div class="wizard-snack-card__copy">' +
            '<h3 class="wizard-h5" data-open-flavor-modal="' + modal + '" role="button" tabindex="0"><span class="accent accent--' + accent + ' shape_' + shape + (label.length >= 10 ? ' accent--long' : ' nowrap') + '" data-snack-title="' + item.id + '">' + esc(label) + '</span></h3>' +
            '<p class="wizard-price" data-snack-price="' + item.id + '">' + snackPriceHtml(handler, item, variant, gift) + '</p>' +
            '<button type="button" class="wizard-text-link" data-open-flavor-modal="' + modal + '">' + esc(t(handler, 'quiz.wizard_4.flavors.details')) + '</button>' +
            warn +
          '</div>' +
        '</div>' +
        action +
      '</article>'
    );
  }

  function mountSnacks(handler) {
    var root = handler.currentStepElement.querySelector('[data-wizard-extras]');
    if (!root) return;
    var state = handler.flow.state;
    state.scoopOn = true;
    var model = household(handler);
    var names = joinNames(model.dogs.map(function (dog) { return dog.name; }));
    var name = model.dogs.length > 1 ? names : (model.dogs[0] && model.dogs[0].name) || '';
    var large = state.largeDogOffer === 'accept' && state.combinedWeightKg() >= 30;
    var introKey = model.dogs.length > 1
      ? (large ? 'quiz.wizard_4.snacks.intro_several_large' : 'quiz.wizard_4.snacks.intro_several')
      : (large ? 'quiz.wizard_4.snacks.intro_large' : 'quiz.wizard_4.snacks.intro');
    var title = t(handler, 'quiz.wizard_4.snacks.title').replace(
      /\s*%\{name\}\s*/g,
      accentedNames(model.dogs.map(function (dog) { return dog.name; }))
    );
    var giftId = freeGiftId(model.dogs);
    var gift = EXTRAS.find(function (item) { return item.id === giftId; });
    var paid = EXTRAS.filter(function (item) { return item.id !== giftId; });
    var cards = (gift ? snackCardHtml(handler, gift, 0, { gift: true, dogs: model.dogs }) : '') +
      paid.map(function (item, index) {
        return snackCardHtml(handler, item, index + 1, { dogs: model.dogs });
      }).join('');
    root.innerHTML =
      '<h2 class="quiz-title">' + title + '</h2>' +
      '<p class="wizard-support wizard-center">' + esc(t(handler, introKey, { name: name })) + '</p>' +
      '<div class="wizard-snack-list">' + cards + '</div>';
    root.querySelectorAll('[data-snack-toggle]').forEach(function (button) {
      button.addEventListener('click', function () {
        var id = button.getAttribute('data-snack-toggle');
        state.extrasOn[id] = !state.extrasOn[id];
        var card = root.querySelector('[data-snack="' + id + '"]');
        if (card) paintSnackCard(handler, card);
      });
    });
    var giftButton = root.querySelector('[data-gift-toggle]');
    if (giftButton) {
      giftButton.addEventListener('click', function () {
        var id = giftButton.getAttribute('data-gift-toggle');
        state.freeGiftOff = giftIsOn(state, id) ? id : '';
        var card = root.querySelector('[data-snack="' + id + '"]');
        if (card) paintGiftCard(handler, card, id);
      });
    }
    setFooter('extras');
    paintSticky(handler, household(handler));
    if (handler.updateButtonStates) handler.updateButtonStates('extras');
  }

  function snackButtonLabel(handler, id, on) {
    if (id === 'scoop') return t(handler, on ? 'quiz.wizard_4.snacks.remove' : 'quiz.wizard_4.snacks.add');
    return t(handler, on ? 'quiz.wizard_4.snacks.remove' : 'quiz.wizard_4.snacks.add');
  }

  function paintGiftCard(handler, card, id) {
    var on = giftIsOn(handler.flow.state, id);
    var button = card.querySelector('[data-gift-toggle]');
    if (button) {
      button.className = on ? 'wizard-card-button' : 'wizard-primary-button';
      button.textContent = snackButtonLabel(handler, id, on);
    }
    var badge = card.querySelector('[data-gift-badge]');
    if (on && !badge) card.insertAdjacentHTML('afterbegin', giftBadgeHtml(handler));
    else if (!on && badge) badge.remove();
  }

  function paintSnackCard(handler, card) {
    var id = card.getAttribute('data-snack');
    if (!id || id === 'scoop') return;
    var on = !!handler.flow.state.extrasOn[id];
    card.classList.toggle('is-selected', on);
    var button = card.querySelector('[data-snack-toggle]');
    if (button) {
      button.className = on ? 'wizard-card-button' : 'wizard-primary-button';
      button.textContent = snackButtonLabel(handler, id, on);
    }
    var badge = card.querySelector('[data-snack-badge]');
    if (on && !badge) {
      card.insertAdjacentHTML(
        'afterbegin',
        '<span class="wizard-edge-badge" data-snack-badge><img alt="" src="' + ADDED_TICK + '">' + esc(t(handler, 'quiz.wizard_4.snacks.added')) + '</span>'
      );
    } else if (!on && badge) {
      badge.remove();
    }
  }

  function flavorQtyParts(handler, bags, selected) {
    var flavors = selected || [];
    if (!flavors.length || !bags) return [];
    if (!window.FlavorDistribution) {
      var only = firstFlavor(flavors);
      return only ? [bags + 'x ' + flavorName(handler, only)] : [];
    }
    var dist = window.FlavorDistribution.calculateFlavorDistribution(bags, flavors);
    var parts = [];
    ORDER.forEach(function (id) {
      if (dist[id]) parts.push(dist[id] + 'x ' + flavorName(handler, id));
    });
    return parts;
  }

  function lineForDog(handler, dog, bags) {
    var parts = flavorQtyParts(handler, bags, dog.flavors || []);
    if (!parts.length) return '';
    return dog.name + ': ' + parts.join(', ');
  }

  function ongoingLineForDog(handler, dog, bags) {
    return lineForDog(handler, dog, bags);
  }

  function moneyStringToCents(value) {
    if (value == null) return 0;
    var s = String(value).trim();
    if (!s) return 0;
    var match = s.match(/^(-?\d+)(?:\.(\d+))?$/);
    if (!match) {
      var n = Number(s);
      return Number.isFinite(n) ? Math.round(n * 100) : 0;
    }
    var sign = match[1].indexOf('-') === 0 ? -1 : 1;
    var intPart = Math.abs(parseInt(match[1], 10)) || 0;
    var frac = (match[2] || '') + '000';
    var cents2 = (parseInt(frac.charAt(0), 10) || 0) * 10 + (parseInt(frac.charAt(1), 10) || 0);
    var cents = intPart * 100 + cents2 + ((parseInt(frac.charAt(2), 10) || 0) >= 5 ? 1 : 0);
    return sign * cents;
  }

  function presentmentCurrency(handler, fromVariant) {
    if (fromVariant) return String(fromVariant).toUpperCase();
    if (handler.getWizardPresentmentCurrencyCode) return handler.getWizardPresentmentCurrencyCode();
    var active = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    return active ? String(active).toUpperCase() : 'EUR';
  }

  function formatPresentment(handler, cents, currency) {
    var code = presentmentCurrency(handler, currency);
    var locale = handler.getWizardFormatLocaleForMoney && handler.getWizardFormatLocaleForMoney();
    if (typeof window.formatMoney === 'function') return window.formatMoney(Math.round(cents) / 100, code, locale);
    return (Math.round(cents) / 100).toFixed(2);
  }

  function foodVariantRows(handler) {
    return configOf(handler).ongoingVariants || [];
  }

  function findFoodVariant(handler, model, flavor) {
    var portion = model.mostly ? 'mostly' : 'complete';
    // Cap like checkout box SKUs (wholeKg). Raw combined kg can exceed the top
    // band (24–100) on large multi-dog households and would otherwise leave
    // _first_box_products / _subscription_products as [].
    var kg = wholeKg(model.combinedKg);
    var rows = foodVariantRows(handler);
    var match = rows.find(function (variant) {
      return variant.flavor === flavor && variant.portion === portion &&
        kg >= variant.min_kg && kg <= variant.max_kg;
    });
    if (match) return match;
    var sameFlavor = rows.filter(function (variant) {
      return variant.flavor === flavor && (variant.portion || 'complete') === portion;
    });
    return sameFlavor[sameFlavor.length - 1] || null;
  }

  function explodeAddsLines() {
    var journey = window.BzWizard && window.BzWizard.current && window.BzWizard.current();
    return !!(journey && journey.fulfillment && journey.fulfillment.explode_strategy === 'worker_add_lines');
  }

  function firstBoxLines(handler, model) {
    var byId = {};
    model.dogs.forEach(function (dog, index) {
      var selected = dog.flavors || [];
      var dist = window.FlavorDistribution
        ? window.FlavorDistribution.calculateFlavorDistribution(model.plans[index].trialBags, selected)
        : {};
      ORDER.forEach(function (id) {
        var qty = dist[id] || 0;
        if (!qty) return;
        var row = findFoodVariant(handler, model, id);
        if (!row || !row.shopify_variant_id) return;
        var key = String(row.shopify_variant_id);
        byId[key] = (byId[key] || 0) + qty;
      });
    });
    return Object.keys(byId).map(function (id) {
      return { variant_id: id, quantity: byId[id] };
    });
  }

  function ongoingLines(handler, model) {
    var byId = {};
    model.dogs.forEach(function (dog, index) {
      var selected = dog.flavors || [];
      var dist = window.FlavorDistribution
        ? window.FlavorDistribution.calculateFlavorDistribution(model.plans[index].ongoingBags, selected)
        : {};
      ORDER.forEach(function (id) {
        var qty = dist[id] || 0;
        if (!qty) return;
        var row = findFoodVariant(handler, model, id);
        if (!row || !row.shopify_variant_id) return;
        var key = String(row.shopify_variant_id);
        byId[key] = (byId[key] || 0) + qty;
      });
    });
    return Object.keys(byId).map(function (id) { return { id: id, qty: byId[id] }; });
  }

  async function ongoingDailyAmount(handler, model) {
    var api = handler.flow && handler.flow.shopifyAPI;
    var lines = ongoingLines(handler, model);
    if (!api || !api.getVariant || !lines.length) return '';
    var variants = await Promise.all(lines.map(function (line) { return api.getVariant(line.id); }));
    var currency = '';
    var totalCents = 0;
    lines.forEach(function (line, index) {
      var variant = variants[index];
      if (!variant || variant.price == null) return;
      if (!currency && variant.currency) currency = variant.currency;
      totalCents += moneyStringToCents(variant.price) * line.qty;
    });
    if (!totalCents) return '';
    var days = Math.max(1, Math.round(model.ongoingDays));
    var dailyCents = Math.round(Math.round(totalCents * 0.9) / days);
    return formatPresentment(handler, dailyCents, currency);
  }

  function repeatsClause(handler, days, amount) {
    var count = Math.max(1, Math.round(days));
    if (amount) {
      var key = count === 1 ? 'quiz.wizard_4.cart.repeats_priced_one' : 'quiz.wizard_4.cart.repeats_priced';
      var priced = t(handler, key, { days: String(count), amount: amount });
      if (priced && priced !== key) return priced;
    }
    return t(handler, 'quiz.wizard_4.cart.repeats', { days: dayWord(handler, count) });
  }

  async function buildCheckout(handler) {
    if (window.BzWizard && window.BzWizard.id() === 'w3' && window.WizardW3) {
      return window.WizardW3.buildCheckout(handler);
    }
    if (window.BzWizard && window.BzWizard.id && window.BzWizard.id() === 'w5' && window.WizardW5) {
      return window.WizardW5.buildCheckout(handler);
    }
    var state = handler.flow.state;
    var model = household(handler);
    var config = configOf(handler);
    var firstParts = [];
    var nextParts = [];
    model.dogs.forEach(function (dog, index) {
      var plan = model.plans[index];
      var first = lineForDog(handler, dog, plan.trialBags);
      var next = ongoingLineForDog(handler, dog, plan.ongoingBags);
      if (first) firstParts.push(first);
      if (next) nextParts.push(next);
    });
    var firstValue = firstParts.join(' · ');
    var days = Math.max(1, Math.round(model.ongoingDays));
    var dailyAmount = '';
    try {
      dailyAmount = await ongoingDailyAmount(handler, model);
    } catch (e) {}
    var nextValue = nextParts.join(' · ') + ' (' + repeatsClause(handler, days, dailyAmount) + ')';
    var offset = Math.min(100, Math.max(1, Math.round(model.shownFoodDays + (model.transitionDays || 0) + model.shippingDays)));
    var planDays = Math.min(100, days);
    var trialMap = config.trialSellingPlanMapping || {};
    var trialPlan = trialMap[String(offset)] || trialMap[offset];
    var fullMap = config.sellingPlanMapping || {};
    var fullPlan = fullMap[String(planDays)] || fullMap[planDays];
    if (!trialPlan || !fullPlan) {
      throw new Error('No selling plan for ' + offset + ' / ' + planDays + ' days');
    }
    var variantId = parseInt(String(model.box && model.box.shopify_variant_id), 10);
    var portion = model.mostly ? 'mostly' : 'complete';
    var subscriptionProducts = [];
    model.dogs.forEach(function (dog, index) {
      var selected = dog.flavors || [];
      var dist = window.FlavorDistribution
        ? window.FlavorDistribution.calculateFlavorDistribution(model.plans[index].ongoingBags, selected)
        : {};
      ORDER.forEach(function (id) {
        var qty = dist[id] || 0;
        if (!qty) return;
        var row = findFoodVariant(handler, model, id);
        if (!row) return;
        var entry = {
          variant_id: 'gid://shopify/ProductVariant/' + row.shopify_variant_id,
          quantity: qty
        };
        if (dog.petMetaobjectId) entry.pet_metaobject_id = String(dog.petMetaobjectId);
        subscriptionProducts.push(entry);
      });
    });
    var properties = {
      [t(handler, 'quiz.wizard_4.cart.this_box')]: firstValue,
      [t(handler, 'quiz.wizard_4.cart.next_box')]: nextValue,
      _acquisition_flow: window.BzWizard.flow(),
      _journey_id: window.BzWizard.id(),
      _plan_type: window.BzWizard.current().pricing.first_box_kind,
      _plan_bowl: portion,
      _next_shipment_offset_days: String(offset),
      _shown_food_days: String(Math.max(1, Math.round(model.shownFoodDays))),
      _full_selling_plan: fullPlan ? String(fullPlan) : '',
      _subscription_products: JSON.stringify(subscriptionProducts),
      ...(explodeAddsLines() ? { _first_box_products: JSON.stringify(firstBoxLines(handler, model)) } : {}),
      _journey_payload: JSON.stringify(model.dogs.map(function (dog, index) {
        return {
          name: dog.name,
          flavors: dog.flavors || [],
          trialBags: model.plans[index].trialBags,
          ongoingBags: model.plans[index].ongoingBags
        };
      }))
    };
    if (state.petMetaobjectId) properties._pet_metaobject_id = String(state.petMetaobjectId);
    var items = [{
      variantId: variantId,
      quantity: 1,
      sellingPlanId: trialPlan,
      properties: properties
    }];
    var sampleCounts = {};
    model.dogs.forEach(function (dog) {
      sampleFlavors(dog).forEach(function (id) {
        sampleCounts[id] = (sampleCounts[id] || 0) + 1;
      });
    });
    Object.keys(sampleCounts).forEach(function (id) {
      items.push({ variantId: parseInt(SAMPLES[id], 10), quantity: sampleCounts[id], properties: giftProps() });
    });
    items.push({ variantId: parseInt(SCOOP_ID, 10), quantity: 1, properties: giftProps() });
    items.push({
      variantId: parseInt(GUIDE_ID, 10),
      quantity: 1,
      properties: giftProps()
    });
    var chosenGift = freeGiftId(model.dogs);
    EXTRAS.forEach(function (extra) {
      var isGift = extra.id === chosenGift && giftIsOn(state, chosenGift);
      if (!isGift && !state.extrasOn[extra.id]) return;
      if (extra.id === chosenGift && !isGift) return;
      items.push({
        variantId: parseInt(extra.variantId, 10),
        quantity: 1,
        sellingPlanId: trialPlan,
        properties: giftProps()
      });
    });
    return {
      cartItems: items,
      distribution: {},
      fullPlanBagCount: model.plans.reduce(function (sum, plan) { return sum + plan.ongoingBags; }, 0),
      matchDays: Math.round(model.ongoingDays),
      multiplier: 1,
      calculations: model.plans[0] ? model.plans[0].calc : {},
      selectedFlavorsTrial: state.selectedFlavorsTrial || [],
      trialVariantId: variantId,
      nextShipmentOffsetDays: offset
    };
  }

  async function removeWizardLines() {
    var cart = await fetch('/cart.js').then(function (response) { return response.json(); });
    var updates = {};
    var scoopId = Number(SCOOP_ID);
    var guideId = Number(GUIDE_ID);
    (cart.items || []).forEach(function (item) {
      var props = item.properties || {};
      var variantId = Number(item.variant_id);
      if ((window.BZ_WIZARD_JOURNEYS || {})[props._journey_id]) updates[item.key] = 0;
      else if (props._acquisition_flow === 'wizard-2') updates[item.key] = 0;
      else if (variantId === scoopId || variantId === guideId) updates[item.key] = 0;
    });
    if (!Object.keys(updates).length) return;
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    });
  }

  function snackPriceHtml(handler, item, variant, gift) {
    var freeWord = '<span class="wizard-price-free">' + esc(t(handler, 'quiz.wizard_4.snacks.free')) + '</span>';
    if (item.id === 'scoop') return freeWord;
    if (gift) {
      var giftFull = Number(variant && variant.price && (variant.price.amount || variant.price)) || 0;
      if (!giftFull) return freeWord;
      return '<span class="wizard-price-was">' + esc(money(giftFull)) + '</span> ' + freeWord;
    }
    if (!variant) return '';
    var full = Number(variant.price && (variant.price.amount || variant.price)) || 0;
    var snackState = handler.flow && handler.flow.state;
    var rate = snackState && snackState.largeDogOffer === 'accept' && snackState.combinedWeightKg() >= 30 ? 0.65 : 0.75;
    return '<span class="wizard-price-was">' + esc(money(full)) + '</span> <span class="wizard-price-now">' + esc(money(full * rate)) + '</span>';
  }

  function mountExtrasWhenReady(handler) {
    var stepNow = function () {
      var current = handler.flow.state.getCurrentStep && handler.flow.state.getCurrentStep();
      return current === 'extras' || current === 'plan_snacks';
    };
    if (extraItems().every(function (item) { return extraMedia[item.id]; })) {
      mountSnacks(handler);
      return;
    }
    var pending = preloadExtras(handler.flow);
    if (!pending) return;
    pending.then(function () {
      if (stepNow()) mountSnacks(handler);
    }).catch(function () {});
  }

  function mount(handler, step) {
    if (window.BzWizard && window.BzWizard.id() === 'w3' && window.WizardW3) {
      window.WizardW3.mount(handler, step);
      return;
    }
    if (step === 'flavors') mountFlavors(handler);
    if (step === 'plan_overview') mountOverview(handler);
    if (step === 'extras' || step === 'plan_snacks') mountExtrasWhenReady(handler);
  }

  function buyboxSnapshot(handler) {
    if (!handler || !window.FlavorDistribution || !window.BzWizard) return null;
    var model = household(handler);
    var flavors = { rund: 0, kip: 0, vis: 0 };
    var bags = 0;
    var any = false;
    model.dogs.forEach(function (dog, index) {
      var selected = (dog.flavors || []).filter(function (id) {
        return id === 'rund' || id === 'kip' || id === 'vis';
      });
      if (!selected.length) return;
      any = true;
      var count = model.plans[index].ongoingBags;
      if (window.BzWizard.id() === 'w5' && window.WizardW5 && window.WizardW5.bagsForDog) {
        count = window.WizardW5.bagsForDog(handler, dog);
      }
      var dist = window.FlavorDistribution.calculateFlavorDistribution(count, selected);
      ORDER.forEach(function (id) {
        var qty = dist[id] || 0;
        flavors[id] += qty;
        bags += qty;
      });
    });
    if (!any || !bags || !model.combinedKg) return null;
    return {
      journeyId: window.BzWizard.id(),
      kg: model.combinedKg,
      bags: bags,
      flavors: flavors
    };
  }

  window.WizardPlan = {
    mount: mount,
    buyboxSnapshot: buyboxSnapshot,
    preloadExtras: preloadExtras,
    canContinueFlavors: function (state) { return canContinueFlavors(state); },
    advanceFlavors: advanceFlavors,
    buildCheckout: buildCheckout,
    checkoutBox: function (handler) { return household(handler).box; },
    removeWizardLines: removeWizardLines,
    household: household,
    giftDiscountCode: function (state) {
      if (!state || !window.BzWizard || window.BzWizard.id() !== 'w4') return '';
      var dogs = state.ensureDogs ? state.ensureDogs() : [];
      var id = freeGiftId(dogs);
      if (!giftIsOn(state, id)) return '';
      var pair = GIFT_CODE[id];
      if (!pair) return '';
      if (window.BzWizard && window.BzWizard.discountCode) return window.BzWizard.discountCode(pair[0], pair[1]);
      return pair[0];
    }
  };
})();
